import type { Time } from "../types/Units"

/**
 * Creates a UTC Unix timestamp (seconds since epoch)
 * @param date - Optional Date object. If undefined, uses current time
 * @returns Time branded number representing UTC Unix time
 *
 * @example
 * ```ts
 * import { UnixTime } from "@pdfking/tfunc"
 *
 * UnixTime() // 1732118400 (current time)
 * UnixTime(new Date('2025-01-01T00:00:00Z')) // 1735689600
 * ```
 */
export const UnixTime = (date?: Date): Time =>
  ((date ? date.getTime() : Date.now()) / 1000) as Time
